import { authFetch } from "./utils/authFetch";

export async function getUnreadCount(): Promise<number> {
  try {
    const res = await authFetch(
      `${process.env.REACT_APP_API_URL}/api/notifications/unread-count`
    );

    if (!res.ok) return 0;
    const { count } = await res.json();
    return count ?? 0;
  } catch {
    return 0;
  }
}

export async function getNotifications(skip = 0, take = 20) {
  const res = await authFetch(
    `${process.env.REACT_APP_API_URL}/api/notifications?skip=${skip}&take=${take}`
  );
  if (!res.ok) throw new Error("Failed to load notifications");
  return res.json() as Promise<{ items: any[]; unread: number }>;
}

export async function markRead(ids: number[]) {
  const res = await authFetch(
    `${process.env.REACT_APP_API_URL}/api/notifications/mark-read`,
    {
      method: "POST",
      body: JSON.stringify({ Ids: ids }),
    }
  );
  if (!res.ok) throw new Error("Failed to mark as read");
}
